import { getApiBaseUrl } from '../config/api';

const API_URL = getApiBaseUrl();

/** Reason codes accepted by report_content.php (keep in sync with cool_report_reasons()). */
export const REPORT_REASONS = [
  { id: 'spam', label: 'Spam or scam' },
  { id: 'harassment', label: 'Harassment or bullying' },
  { id: 'hate', label: 'Hate speech' },
  { id: 'inappropriate', label: 'Nudity or inappropriate content' },
  { id: 'misinformation', label: 'False information' },
  { id: 'impersonation', label: 'Fake account or impersonation' },
  { id: 'other', label: 'Something else' },
];

async function postJson(path, body) {
  try {
    const res = await fetch(`${API_URL}/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    return await res.json();
  } catch (err) {
    console.error(`${path} failed`, err);
    return { success: false, message: 'Network error. Please try again.' };
  }
}

/** targetType: 'post' | 'reply' | 'user' */
export function reportContent(userId, targetType, targetId, reason, details = '') {
  return postJson('report_content.php', {
    user_id: userId,
    target_type: targetType,
    target_id: targetId,
    reason,
    details,
  });
}

export function blockUser(userId, targetId) {
  return postJson('block_user.php', { user_id: userId, target_id: targetId });
}

export function unblockUser(userId, targetId) {
  return postJson('unblock_user.php', { user_id: userId, target_id: targetId });
}

export async function fetchBlockedUsers(userId) {
  try {
    const res = await fetch(`${API_URL}/get_blocked_users.php?user_id=${encodeURIComponent(userId)}`);
    const data = await res.json();
    return data.success ? data.users || [] : [];
  } catch (err) {
    console.error('get_blocked_users failed', err);
    return [];
  }
}

export async function fetchReports(adminId, status = 'open') {
  try {
    const params = new URLSearchParams({ admin_id: String(adminId), status });
    const res = await fetch(`${API_URL}/get_reports.php?${params.toString()}`);
    return await res.json();
  } catch (err) {
    console.error('get_reports failed', err);
    return { success: false, reports: [], open_count: 0 };
  }
}

/** status: 'actioned' | 'dismissed' | 'open' */
export function resolveReport(adminId, reportId, status, note = '') {
  return postJson('resolve_report.php', {
    admin_id: adminId,
    report_id: reportId,
    status,
    note,
  });
}

/**
 * Confirm, then block. Returns true when the block went through.
 * Shared so every "Block" entry point asks the same question.
 */
export async function confirmAndBlock(user, target) {
  if (!user?.id || !target?.id) return false;
  const name = target.name || 'this member';
  const ok = window.confirm(
    `Block ${name}?\n\nYou won't see each other's posts or comments, and they can't message you, connect, or follow you. Any connection between you will be removed. You can unblock them later from My Network.`
  );
  if (!ok) return false;
  const result = await blockUser(user.id, target.id);
  alert(result.message || (result.success ? 'User blocked.' : 'Failed to block user.'));
  return Boolean(result.success);
}
